import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white px-6 py-20 sm:py-24" aria-labelledby="faq-titulo" data-id="element-28" data-mp="1bmvdgxk5o8r8">
      <div className="mx-auto max-w-3xl" data-id="element-29" data-mp="1glgegz78ewgq">
        <h2 id="faq-titulo" className="font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl" data-id="element-30" data-mp="248y00czwkyb9">
          Preguntas frecuentes
        </h2>

        <ul className="mt-10 divide-y divide-cream-200 border-y border-cream-200" data-id="element-31" data-mp="1ujwlkr90aoze">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          return <li key={question} data-id="element-32" data-mp="2n7sbnd42lin7" data-mpi={index}>
                <h3 data-id="element-33" data-mp="2n6r1dauvp06j">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left font-display text-lg font-semibold text-forest-800 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-34" data-mp="2n67h3nhr9zpc">
                    {question}
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-35" data-mp="19su07qj22q81" /> : <PlusIcon className="h-5 w-5 shrink-0 text-forest-400" aria-hidden="true" data-id="element-36" data-mp="1oldwc77sfxfz" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-37" data-mp="1xioca5vjwar8">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-38" data-mp="1skmpb9v07rah">
                      <p className="pb-6 pr-10 text-base leading-relaxed text-forest-700/75" data-id="element-39" data-mp="1ybfuwgkcykh2">{answer}</p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}